import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';
import { HeaderTypography, RecordTableCell } from '../../utilComponents/StyledComponents';
import { useNavigate } from 'react-router-dom';


const GrandPrixOverview = ({ records, places }) => {
    const navigate = useNavigate();
    // Sort the records by finalScore in descending order
    const sortedRecords = [...records].sort((a, b) => b.finalScore - a.finalScore);
    const sortedPlaces = [...places].sort((a, b) => b.firsts - a.firsts);

    const TableTitle = ({ titleName }) => (

        <Box sx={{
            // display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 2,
        }}>
            <Typography variant="h8" sx={{ fontFamily: '"Press Start 2P", sans-serif', fontWeight: 'bold', fontSize: '.75rem' }}>{titleName}</Typography>
        </Box>

    )


    return (
        <Box >
            <Box sx={{ mt: 1 }} >
                <TableTitle titleName='Final Stats' />
                <Box sx={{ maxWidth: '90vw', alignItems: 'center', justifyContent: 'center', width: "400px"}}>
                <Paper sx={{ maxWidth: '90vw', mb: 2, overflow: 'hidden', width: "400px"}}>
                <TableContainer
                    component={Paper}
                    sx={{
                        maxWidth: '95%',
                        backgroundColor: '#4A4A4A',
                        borderRadius: 2,
                        padding: 1
                    }}
                >
                    <Table
                        sx={{
                            tableLayout: 'fixed',
                            '& .MuiTableCell-root': {
                                padding: '4px',
                                fontSize: {
                                    xs: '0.6rem',
                                    sm: '0.75rem',
                                    md: '0.875rem',
                                },
                            },
                        }}
                        size="small"
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ width: '25%' }}>
                                    <HeaderTypography headerName="Name" sx={{ whiteSpace: 'nowrap', fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                } }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '20%' }}>
                                    <HeaderTypography headerName="Score" sx={{ whiteSpace: 'nowrap', fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                } }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '20%' }}>
                                    <HeaderTypography headerName="APN" sx={{ whiteSpace: 'nowrap', fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                } }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '35%' }}>
                                    <HeaderTypography headerName="Relative Win %" sx={{fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                }}}/>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedRecords.map((record, index) => (
                                <TableRow 
                                    key={record.playerId}
                                    sx={{ cursor: 'pointer', backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white'}}
                                    hover
                                    onClick={() => navigate(`/stats/players/${record.playerId}`)} // Use navigate to go to player page
                                >
                                    <RecordTableCell recordValue={`${record.firstName} ${record.lastName}`}
                                    
                                    />
                                    <RecordTableCell recordValue={record.finalScore} />
                                    <RecordTableCell recordValue={record.apn} />
                                    <RecordTableCell recordValue={record.relativeWinPercent.toFixed(2)} />
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                </Paper>
                </Box>
            </Box>
            <Box sx={{ mt: 4 }}>

                <TableTitle titleName='Final Places' />
                <Box sx={{ maxWidth: '90vw', alignItems: 'center', justifyContent: 'center', width: "400px"}}>
                <Paper sx={{ maxWidth: '90vw', mb: 2, overflow: 'hidden', width: "400px"}}>
                <TableContainer
                    component={Paper}
                    sx={{
                        maxWidth: '95%',
                        backgroundColor: '#4A4A4A',
                        borderRadius: 2,
                        padding: 1,
                    }}
                >
                    <Table
                        sx={{
                            tableLayout: 'fixed',
                            '& .MuiTableCell-root': {
                                padding: '4px',
                                fontSize: {
                                    xs: '0.6rem',
                                    sm: '0.75rem',
                                    md: '0.875rem',
                                },
                            },
                        }}
                        size="small"
                    >
                        <TableHead>
                            <TableRow 
                            >
                                <TableCell align="center" sx={{ width: '25%' }}>
                                    <HeaderTypography headerName="Name" sx={{ whiteSpace: 'nowrap', fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                } }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '25%' }}>
                                    <HeaderTypography headerName="Firsts" sx={{ whiteSpace: 'nowrap', fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                } }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '25%' }}>
                                    <HeaderTypography headerName="Seconds" sx={{ whiteSpace: 'nowrap', fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                } }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '25%' }}>
                                    <HeaderTypography headerName="Lasts" sx={{ whiteSpace: 'nowrap', fontSize: {
                                    xs: '0.5rem',
                                    sm: '0.6rem',
                                    md: '0.7rem',
                                } }} />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedPlaces.map((place, index) => (
                                <TableRow
                                    key={place.playerId}
                                    sx={{ cursor: 'pointer', backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white'}}
                                    hover
                                    onClick={() => navigate(`/stats/players/${place.playerId}`)} // Use navigate to go to player page
                                >
                                    <RecordTableCell recordValue={`${place.firstName} ${place.lastName}`} />
                                    <RecordTableCell recordValue={place.firsts} />
                                    <RecordTableCell recordValue={place.seconds} />
                                    <RecordTableCell recordValue={place.lasts} />
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                </Paper>
                </Box>
            </Box>
        </Box>
    );
};

export default GrandPrixOverview;
